'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("$httpErrorInterceptor", function ($q, $injector) {
  var $httpErrorHandler = null;
  var delegateToErrorHandler = function delegateToErrorHandler(errorResponse) {
    var error = errorResponse.data;
    if (_.isString(error)) {
      error = {
        message: error
      };
    }
    if (error == null) {
      error = {};
    }
    error.httpCode = errorResponse.status;
    $httpErrorHandler.handleServerError(error);
  };
  return {
    responseError: function responseError(errorResponse) {
      if ($httpErrorHandler == null) {
        // avoid cyclic dependency for $http service.
        $httpErrorHandler = $injector.get("$httpErrorHandler");
      }
      if (errorResponse.config && errorResponse.config.silentError === true) {
        return $q.reject(errorResponse);
      }

      // canceled request
      if (errorResponse.status === -1) {
        return $q.reject(errorResponse);
      }
      delegateToErrorHandler(errorResponse);
      return $q.reject(errorResponse);
    }
  };
});
ngModule.config(function ($httpProvider) {
  $httpProvider.interceptors.push('$httpErrorInterceptor');
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/http/httpErrorInterceptor.js
// module id = 2712
// module chunks = 13